<template>
  <div class="card">
    <div class="card-header">
      <h4 class="title">Driver sales</h4>
    </div>
    <div class="card-body">

      <active-filter-list :activeFilters="activeFilters" :tableName="tableName" @remove-filter="removeFilter"
        @clear-filters="clearFilters"></active-filter-list>

      <v-server-table :name="tableName" :url="`/v1/sales?submerchantId=${submerchantId}`" :columns="columns"
        :options="options" :ref="tableName" @filter="addToActiveFilters">
        <template slot="id" slot-scope="props">
          <code>{{ props.row.id }}</code>
        </template>

        <div slot="filter__capturedAt">
          <date-range-picker class="picker" ref="picker" :opens="opens" v-model="dateRange" @update="updateValues"
            style="z-index: 1; position:inherit;">
            <template class="picker-dates" v-slot:input="picker" style="min-width: 350px;">
              {{ picker.startDate ? `${picker.startDate.toISOString().split('T')[0]} -` : "Select date range" }}
              {{ picker.endDate ? picker.endDate.toISOString().split('T')[0] : "" }}
            </template>
          </date-range-picker>
        </div>

        <template slot="capturedAt" slot-scope="props">
          <div>{{ props.row.capturedAt | moment("YYYY-MM-DD HH:mm A") }}</div>
        </template>

        <template slot="amount" slot-scope="props">
          <span>{{ props.row.amount | money(props.row.currency) }}</span>
        </template>

        <template slot="panLastFour" slot-scope="props">
          <div>************{{ props.row.panLastFour }}</div>
        </template>

        <template slot="authCode" slot-scope="props">
          <code>{{ props.row.authCode }}</code>
        </template>

        <template slot="externalReference" slot-scope="props">
          <code v-if="props.row.externalReference">{{
            props.row.externalReference
          }}</code>
        </template>

        <template slot="terminalSerialNumber" slot-scope="props">
          <terminal-fragment :terminalId="props.row.terminalId" :terminalSerialNumber="props.row.terminalSerialNumber"
            link-classes="btn btn-link btn-sm" :key="props.row.id"></terminal-fragment>
        </template>

        <template slot="links" slot-scope="props">
          <router-link :to="`/transactions/sales/${props.row.id}`" class="btn btn-default btn-sm">
            View &nbsp;
            <i class="fa fa-chevron-right"></i>
          </router-link>
        </template>
      </v-server-table>
    </div>
  </div>
</template>
<script>
import _ from "lodash";

import { requestAdapter } from "../../../../helpers/tableHelpers";
import TerminalFragment from "src/components/Dashboard/Views/Pages/Terminals/TerminalFragment.vue";
import ActiveFilterList from "src/components/UIComponents/ActiveFilterList.vue";

// datepicker table filter dependencies
import jquery from "jquery";
import moment from "moment";
import DateRangePicker from "vue2-daterange-picker";
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';
import { Event } from 'vue-tables-2-premium'

window.$ = jquery;
window.moment = moment;

const columns = [
  "id",
  "amount",
  "cardScheme",
  "terminalSerialNumber",
  "cardType",
  "authCode",
  "panLastFour",
  "capturedAt",
  "externalReference",
  "links"
];

export default {
  name: "SubmerchantSalesList",
  components: {
    TerminalFragment,
    ActiveFilterList,
    DateRangePicker
  },
  props: ["submerchantId"],
  methods: {
    clearFilters() {
      this.$refs[this.tableName].resetQuery();
      this.$refs[this.tableName].resetCustomFilters();
      this.activeFilters = [];

    },
    containsObject(obj, list) {
      for (const i in list) {
        if (obj.name === list[i].name) {
          return true;
        }
      }
      return false;
    },
    removeFilter(filter) {
      if (filter.name === 'date') {
        filter.name = 'capturedAt';
        Event.$emit(`vue-tables.${this.tableName}.filter::${filter.name}`, "");
      } else {
        const filterObj = {}
        filterObj[filter.name] = '';
        this.$refs[this.tableName].setFilter(filterObj);
      }
    },
    addToActiveFilters(filter) {
      let isDuplicate = this.containsObject(filter, this.activeFilters)

      if (filter.value !== '' && !isDuplicate) {
        this.activeFilters.push(filter)
      } else if (filter.value === '') {
        const index = this.activeFilters.indexOf(filter)
        this.activeFilters.splice(index, 1)
      }
    },
    loadActiveFilters() {
      const tableData = this.$refs[this.tableName].getRequestParams();
      const activeQueries = tableData['query'];

      if (tableData['capturedAt'] !== null || '') {
        activeQueries.date = tableData['capturedAt']
      }

      for (let query in activeQueries) {
        if (activeQueries[query] !== '') {
          const queryObj = { name: query, value: activeQueries[query] };
          this.activeFilters.push(queryObj);
        }
      }
    },
    updateValues(vals) {
      let filter = { name: "date", value: vals };
      let isDuplicate = this.containsObject(filter, this.activeFilters);
      if (!isDuplicate) {
        this.activeFilters.push(filter);
      }
      Event.$emit(`vue-tables.${this.tableName}.filter::capturedAt`, { start: moment(vals.startDate).startOf('day'), end: moment(vals.endDate).endOf('day') });
    },
  },
  mounted() {
    this.loadActiveFilters();
  },
  data() {
    return {
      columns,
      tableName: `submerchantSalesList_${this.submerchantId}`,
      activeFilters: [],
      options: {
        name: this.tableName,
        table: this.tableName,
        filterByColumn: true,
        pagination: { chunk: 3, dropdown: false },
        requestAdapter,
        columnsDropdown: false,
        columnsDisplay: {
          amount: "min_mobileP",
          cardScheme: "min_desktop",
          terminalSerialNumber: "min_desktop",
          cardType: "min_desktop",
          authCode: "min_desktop",
          panLastFour: "min_tabletL",
          capturedAt: "min_mobileL",
          link: "min_mobile"
        },
        headings: {
          link: "",
          amount: "Amount",
          cardScheme: "Scheme",
          terminalSerialNumber: "Terminal",
          cardType: "Card type",
          authCode: "Auth code",
          panLastFour: "PAN (last four)",
          capturedAt: "Date",
          externalReference: "Reference"
        },
        sortable: _.initial(columns),
        customFilters: ["capturedAt"],
        filterable: [
          "cardScheme",
          "cardType",
          "panLastFour",
          "authCode",
          "terminalSerialNumber",
          "externalReference"
        ],
        listColumns: {
          cardScheme: [
            {
              id: "visa",
              text: "Visa"
            },
            {
              id: "mastercard",
              text: "Mastercard"
            },
            {
              id: "american_express",
              text: "American Express"
            }
          ],
          cardType: [
            {
              id: "credit",
              text: "Credit"
            },
            {
              id: "debit",
              text: "Debit"
            }
          ]
        }
      },
      dateRange: {
        startDate: null,
        endDate: null
      },
      opens: 'left'
    };
  }
};
</script>
